<template>



  <!--  ==============================  MODAL_SECTION START ============================== -->
  <b-modal
    id="modal-add-transport"
    :title="editMode == true ?  $t('edition') : $t('add_transport')"
    cancel-variant="outline-secondary"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @cancel="onCancel"
    @close="onCancel"
    @show="showModal"
    @ok="onSubmitMoney"
  >
    <b-form>
      <validation-observer ref="moneyValidations">


        <b-form-group :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('namee')"
            rules="required"
          >
            <b-form-input v-model="title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>


        <b-form-group
          :label="$t('reference.ins_photo')"
        >
          <!-- <validation-provider
            #default="{ errors }"
            :name="$t('reference.ins_photo')"
            rules="required"
          > -->
            <b-form-file
              v-model="image"
              :placeholder="$t('reference.upload_photo')"
              :browse-text="$t('upload')"
            />
            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
          <!-- </validation-provider> -->
        </b-form-group>


      </validation-observer>
    </b-form>
  </b-modal>
  <!--  ==============================  MODAL_SECTION END ============================== -->




  
</template>

<script>
import { BModal, VBModal, BForm, BFormInput, BFormGroup, BFormFile } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormFile,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    editTransport: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      title: "",
      image: null,
      editMode: false,
      // ===============  PRIMARY_DATA_SECTION END ===============




    };
  },
  methods: {
    ...mapActions("transport", [
      "CREATE_TRANSPORT",
      "UPDATE_PUT_TRANSPORT",
    ]),





    // ===============  ON_SHOW_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode
      
      if (!this.editTransport) {
        return;
      }

      if (typeof this.editTransport === "object" && this.editTransport !== null) {
        this.title = this.editTransport.title;
        this.image = this.editTransport.image;
      }
    },
    // ===============  ON_SHOW_SECTION END ===============





    onCancel(){
      this.$route.params.editMode = false
    },
    onClose(){
      this.$route.params.editMode = false
    },




    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitMoney(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.moneyValidations.validate().then((success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }

        const formData = new FormData()
      
        try {
          if (this.editTransport.id) {
            formData.append('title', this.title)

            if(this.image && typeof this.image != 'string'){
              formData.append('image', this.image)
            }
            this.UPDATE_PUT_TRANSPORT({
              id: this.editTransport.id,
              data: formData,
            }).then(async () => {
              await this.$parent.refresh()
            });
          } else {
            formData.append('title', this.title)
            if(this.image){
              formData.append('image', this.image)
            }
            this.CREATE_TRANSPORT(formData).then(async () => {
              await this.$parent.refresh()
            });
          }
          this.$nextTick(() => {
            this.$route.params.editMode = false
            this.$bvModal.hide("modal-add-transport");
          });

          this.title = ""
          this.image = null

          this.$_okToast();
        } catch (err) {
          this.$_errToast(err);
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
